/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const phoneTeamNumberResponseOutputTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamNumberResponseOutputInboundNumberOneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);

export const PhoneTeamNumberResponseOutput = zod.object({
  teamId: zod.uuid().regex(phoneTeamNumberResponseOutputTeamIdRegExp),
  inboundNumber: zod.union([
    zod.string().regex(phoneTeamNumberResponseOutputInboundNumberOneRegExp),
    zod.null(),
  ]),
});

export type PhoneTeamNumberResponseOutput = zod.input<typeof PhoneTeamNumberResponseOutput>;
export type PhoneTeamNumberResponseOutputOutput = zod.output<typeof PhoneTeamNumberResponseOutput>;
